import React, { useState } from 'react';
import styles from './styles.module.scss';
import Logo from '../../../assets/icons/logo.png';
import PhoneNumber from './PhoneNumber';
import ValidatePhone from './ValidatePhone';
import ChangePassword from './ChangePassword';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { changePassword, getVerificationCode, verifyCode } from './api';
import { routes } from '../../../assets/routes';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../../../i18n/LanguageProvider';

const ResetPassword = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');

  const history = useHistory();

  const sendPhoneNumberMutation = useMutation(getVerificationCode, {
    onError: (err) =>
      toast.error(err.response?.data?.detail || t('common.error')),

    onSuccess: (data) => {
      setPhoneNumber(data.data.phone_number);
      setCurrentStep(1);
    }
  });

  const verifyPhoneNumberMutation = useMutation(verifyCode, {
    onError: (err) => {
      toast.error(err.response?.data?.detail || t('common.error'));
      setCurrentStep(0);
    },

    onSuccess: (data) => {
      localStorage.setItem(
        'change-password-access-token',
        data.data.access_token
      );
      setCurrentStep(2);
    }
  });

  const changePasswordMutation = useMutation(changePassword, {
    onError: (err) =>
      toast.error(err.response?.data?.detail || t('common.error')),

    onSuccess: () => {
      history.push(routes.LOGIN);
    }
  });

  const handleSendPhoneNumber = (phoneNumber) => {
    sendPhoneNumberMutation.mutate({
      phoneNumber
    });
  };

  const handleSendVerificationCode = (verificationCode) => {
    verifyPhoneNumberMutation.mutate({
      phoneNumber,
      verificationCode
    });
  };

  const handleChangePassword = (data) => {
    changePasswordMutation.mutate({
      accessToken: localStorage.getItem('change-password-access-token'),
      password: data.password
    });
  };

  return (
    <div className={styles.page}>
      <div>
        <img src={Logo} alt="reco-logo" className={styles.logo} />
      </div>

      <div className={styles.formsContainer}>
        <div className={currentStep === 0 ? styles.show : styles.hide}>
          <PhoneNumber
            onSubmitPhone={handleSendPhoneNumber}
            loading={sendPhoneNumberMutation.isLoading}
          />
        </div>

        <div className={currentStep === 1 ? styles.show : styles.hide}>
          <ValidatePhone
            getVerificationCodeAgain={handleSendPhoneNumber}
            onSubmitVerificationCode={handleSendVerificationCode}
            onCancel={() => setCurrentStep(0)}
            phoneNumber={phoneNumber}
            loading={verifyPhoneNumberMutation.isLoading}
          />
        </div>

        <div className={currentStep === 2 ? styles.show : styles.hide}>
          <ChangePassword onSubmitPassword={handleChangePassword} />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
